import {
  Checkbox,
  Col,
  Row,
  Select,
  Switch,
  TextField,
} from '@rematter/ui-web';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';

type FreightFormSectionProps = {
  title: string;
  enabled: boolean;
  onEnabledChange: (value: boolean) => void;
  rateFormula: string;
  onRateFormulaChange: (value: string) => void;
  chargebackFormula: string;
  onChargebackFormulaChange: (value: string) => void;
  fuelSurchargeFormula: string;
  onFuelSurchargeFormulaChange: (value: string) => void;
  fuelSurchargeMode: string;
  onFuelSurchargeModeChange: (value: string) => void;
  negativeCharge?: boolean;
  onNegativeChargeChange?: (value: boolean) => void;
  showNegativeCharge?: boolean;
  disabled?: boolean;
};

export const FreightFormSection = ({
  title,
  enabled,
  onEnabledChange,
  rateFormula,
  onRateFormulaChange,
  chargebackFormula,
  onChargebackFormulaChange,
  fuelSurchargeFormula,
  onFuelSurchargeFormulaChange,
  fuelSurchargeMode,
  onFuelSurchargeModeChange,
  negativeCharge,
  onNegativeChargeChange,
  showNegativeCharge = false,
  disabled = false,
}: FreightFormSectionProps) => {
  const t = useTranslations();

  return (
    <Col gap4 className="@FreightFormSection">
      <Row gap2 className="items-center">
        <Switch
          isSelected={enabled}
          onChange={onEnabledChange}
          isDisabled={disabled}
        >
          {title}
        </Switch>
      </Row>

      {enabled && (
        <Col gap4 className="pl-2">
          <div className="grid grid-cols-2 gap-4">
            <TextField
              value={rateFormula}
              label={t.locationFreightPreferences.fields.rateFormula}
              onChange={onRateFormulaChange}
              placeholder={
                t.locationFreightPreferences.placeholders.rateFormula
              }
              isDisabled={disabled}
            />
            <TextField
              value={chargebackFormula}
              label={t.locationFreightPreferences.fields.chargebackFormula}
              onChange={onChargebackFormulaChange}
              placeholder={
                t.locationFreightPreferences.placeholders.chargebackFormula
              }
              isDisabled={disabled}
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <TextField
              value={fuelSurchargeFormula}
              label={t.locationFreightPreferences.fields.fuelSurchargeFormula}
              onChange={onFuelSurchargeFormulaChange}
              placeholder={
                t.locationFreightPreferences.placeholders.fuelSurchargeFormula
              }
              isDisabled={disabled}
            />
            <Select
              value={fuelSurchargeMode || undefined}
              label={t.locationFreightPreferences.fields.fuelSurchargeMode}
              onChange={onFuelSurchargeModeChange}
              placeholder={
                t.locationFreightPreferences.placeholders.fuelSurchargeMode
              }
              options={[
                {
                  key: 'PERCENTAGE',
                  label:
                    t.locationFreightPreferences.fuelSurchargeModes.percentage,
                },
                {
                  key: 'FLAT',
                  label: t.locationFreightPreferences.fuelSurchargeModes.flat,
                },
                {
                  key: 'PER_MILE',
                  label:
                    t.locationFreightPreferences.fuelSurchargeModes.perMile,
                },
              ]}
              isDisabled={disabled}
            />
          </div>

          {showNegativeCharge && (
            <Checkbox
              isSelected={negativeCharge}
              onChange={onNegativeChargeChange}
              isDisabled={disabled}
            >
              {t.locationFreightPreferences.allowNegativeCharges}
            </Checkbox>
          )}
        </Col>
      )}
    </Col>
  );
};
